import React from 'react';
import QuoteLayout from '../../components/QuoteLayout/quote-layout';
import QuoteContext from '../../context/quote-context';
import DateForm from '../../components/GetQuoteSteps/date';

export default function QuoteDatePage() {
  return (
    <QuoteLayout>
      <QuoteContext.Consumer>
        {quote => (
          <DateForm set={quote.set} date={quote.date} />
        )}
      </QuoteContext.Consumer>
    </QuoteLayout>
  );
}
